<ng-template #pinPadContent>
  <div class="pin-pad-content">
    <div class="text-center mb-3">
      <div class="pin-pad-lock mx-auto mb-3" aria-hidden="true">
        <i class="bi bi-shield-lock"></i>
      </div>

      <h5 class="fw-bold mb-1">{{ title }}</h5>
      <div class="text-muted small">{{ description }}</div>
    </div>

    <div
      class="pin-display mb-3"
      role="status"
      aria-live="polite"
      [attr.aria-label]="pin.length + ' of 6 PIN digits entered'">
      <span
        class="pin-dot"
        *ngFor="let slot of pinSlots; let i = index; trackBy: trackByIndex"
        [class.filled]="i < pin.length">
      </span>
    </div>

    <div class="alert alert-danger py-2 small mb-3" *ngIf="error">
      {{ error }}
    </div>

    <div class="pin-grid" aria-label="Account PIN keypad">
      <button
        *ngFor="let digit of digits"
        class="btn pin-key"
        type="button"
        [disabled]="loading"
        [attr.aria-label]="'Enter ' + digit"
        (click)="appendDigit(digit)">
        {{ digit }}
      </button>

      <button
        class="btn pin-key pin-key-action"
        type="button"
        [disabled]="loading || !pin.length"
        aria-label="Clear PIN"
        (click)="clear()">
        Clear
      </button>

      <button
        class="btn pin-key"
        type="button"
        [disabled]="loading"
        aria-label="Enter 0"
        (click)="appendDigit(0)">
        0
      </button>

      <button
        class="btn pin-key pin-key-action"
        type="button"
        [disabled]="loading || !pin.length"
        aria-label="Remove last PIN digit"
        (click)="removeDigit()">
        <i class="bi bi-backspace"></i>
      </button>
    </div>

    <button
      class="btn btn-primary w-100 mt-3"
      type="button"
      [disabled]="loading || !complete"
      (click)="submit()">
      <span *ngIf="loading" class="spinner-border spinner-border-sm me-2"></span>
      {{ loading ? 'Please wait...' : confirmLabel }}
    </button>

    <div class="text-center text-muted small mt-3">
      Your PIN is masked and is never displayed.
    </div>
  </div>
</ng-template>

<div class="pin-pad-inline" *ngIf="!modal">
  <ng-container *ngTemplateOutlet="pinPadContent"></ng-container>
</div>

<div
  class="modal fade"
  [class.show]="visible"
  [style.display]="visible ? 'block' : 'none'"
  tabindex="-1"
  role="dialog"
  aria-modal="true"
  *ngIf="modal && visible">

  <div class="modal-dialog modal-dialog-centered pin-pad-dialog">
    <div class="modal-content border-0 shadow-lg">
      <div class="modal-header border-0 pb-0" *ngIf="showCloseButton">
        <span></span>
        <button
          type="button"
          class="btn-close"
          aria-label="Close"
          [disabled]="loading"
          (click)="close()">
        </button>
      </div>

      <div class="modal-body p-4 pt-2">
        <ng-container *ngTemplateOutlet="pinPadContent"></ng-container>
      </div>
    </div>
  </div>
</div>

<div
  class="modal-backdrop fade show"
  *ngIf="modal && visible"
  (click)="close()">
</div>
